import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import createCoinSubscription from '../../../channels/coin_channel';

const CoinDisplay = (props) => {
  // Log the raw props to see what we're getting
  console.log('CoinDisplay raw props:', props);

  // Extract props with defaults
  const initialCoins = props.initialCoins !== undefined ? props.initialCoins : 0;
  const userId = props.userId !== undefined ? props.userId : null;

  // Convert initialCoins to a number if it's not already
  const parsedInitialCoins = typeof initialCoins === 'number' ? initialCoins : parseInt(initialCoins || '0', 10);

  // Use the parsed value for the initial state
  const [coins, setCoins] = useState(parsedInitialCoins);
  const [animating, setAnimating] = useState(false);

  // Log the initial values to help with debugging
  useEffect(() => {
    console.log('CoinDisplay initialized with:', {
      initialCoins,
      parsedInitialCoins,
      userId
    });
  }, [initialCoins, userId]);

  useEffect(() => {
    // Only subscribe if we have a valid userId
    if (!userId) {
      console.warn('CoinDisplay: No userId provided, skipping subscription');
      return;
    }

    console.log('Creating subscription for user:', userId);

    // Subscribe to the coin channel for real-time updates
    const subscription = createCoinSubscription(userId);

    // Also listen for the custom event (for backward compatibility)
    const handleCoinUpdate = (event) => {
      const { detail } = event;
      console.log('Coin update event received:', event);

      if (detail && detail.userId === userId && detail.coins !== undefined) {
        console.log('Coin update matched for user:', detail);

        // Animate the coin change
        setAnimating(true);
        setCoins(parseInt(detail.coins, 10));

        // Reset animation after a short delay
        setTimeout(() => {
          setAnimating(false);
        }, 1000);
      }
    };

    // Add event listener
    document.addEventListener('coin-update', handleCoinUpdate);

    // Clean up
    return () => {
      document.removeEventListener('coin-update', handleCoinUpdate);
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    };
  }, [userId]);

  return (
    <div className="flex items-center">
      <img src="/assets/coin.png" className="h-8 w-8 mr-1" alt="Coin" />
      <span
        id="current-coin"
        className={`text-xl font-bold ${animating ? 'text-green-500 scale-125 transition-all' : ''}`}
      >
        {coins}
      </span>
    </div>
  );
};

CoinDisplay.propTypes = {
  initialCoins: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CoinDisplay;